
import { ref, defineComponent } from 'vue'
import { mapState, mapGetters, useStore } from 'vuex'
import MoreInfoItem from '@remote/components/MoreInfoItem.vue'
import { CUSTOM_SERVICE_URL, SUBMIT_QUESTION_URL, SYNOLOGY_HELP_URL } from '@remote/constant/index'
import { HotlineTelNumber } from '@remote/constant'
import { isAndroidNative as isAndroid, isIOSNative as isIOS, sendMessage } from '@xunlei/universal-native-api'
import Spin from '@remote/components/Spin.vue'
import { useEnvStore } from '@remote/store/env'
import { toast } from '@remote/utils'

export default defineComponent({
  components: {
    MoreInfoItem,
    Spin,
  },
  setup: () => {
    document.title = '帮助与反馈'
    const store = useStore()
    return { store, HotlineTelNumber }
  },
  data () {
    return { 
      isLoading: false as boolean,
    }
  },
  computed: {
    ...mapState([]),
    ...mapGetters(['isFullScreen']),
  },
  methods: {
    handleBack () {
      this.$router.go(-1)
    },
    goCustomerService () {
      this.store.commit('update', { currentIframeUrl: CUSTOM_SERVICE_URL, currentIframeTitle: '在线客服', currentIframeShowClose: false })
      this.$router.push({
        name: 'pluginIframe',
        query: this.$route.query,
      })
    },
    goHotline () {
      const envStore = useEnvStore()
      if (isIOS) {
        sendMessage({
          platform: 'ios',
          name: 'openURL',
          params: {
            url: `tel:${HotlineTelNumber}`,
            title: '客服热线',
          },
        }, { noCallback: true })
      } else if (envStore.isInPC) {
        toast(`客服热线：${HotlineTelNumber}`)
      } else {
        location.href = `tel:${HotlineTelNumber}`
      }
    },
    goSubmit () {
      if (isAndroid) {
        return sendMessage({
          platform: 'android',
          name: 'xlOpenUrl',
          params: {
            url: SUBMIT_QUESTION_URL,
            openType: 1,
            from: '',
          },
        })
      } 
      else if (isIOS) {
        this.isLoading = true
        setTimeout(() => {
          this.isLoading =  false
          location.assign(
            `xunlei://hybrid/openHybridWeb?url=${decodeURIComponent(SUBMIT_QUESTION_URL)}`,
          )
        }
        , 1000)
        return
      }
      this.goProtocol(SUBMIT_QUESTION_URL, '提交工单')
    },
    goProtocol (url: string, title: string) {
      this.store.commit('update', { currentIframeUrl: url, currentIframeTitle: title, currentIframeShowClose: false })
      this.$router.push({
        name: 'pluginIframe',
        query: this.$route.query,
      })
    },
    goHelp () {
      if (isAndroid) {
        return sendMessage({
          platform: 'android',
          name: 'xlOpenUrl',
          params: {
            url: SYNOLOGY_HELP_URL,
            openType: 1,
            from: '',
          },
        })
      } 
      else if (isIOS) {
        this.isLoading = true
        setTimeout(() => {
          this.isLoading =  false
          location.assign(
            `xunlei://hybrid/openHybridWeb?url=${decodeURIComponent(SYNOLOGY_HELP_URL)}`,
          )
        }
        , 1000)
        return
      }
      this.goProtocol(SYNOLOGY_HELP_URL, '帮助文档')
    },
  },
})
